import { RenderTiles } from "../../components/common";
import ChildHeader from "../../components/ui/ChildHeader";
import { GiRingMould, GiToolbox } from "react-icons/gi";
import { GrVmMaintenance } from "react-icons/gr";
import { FaCalendarAlt } from "react-icons/fa";
import { MdInventory2, MdReceiptLong, MdSummarize } from "react-icons/md";
import { AiOutlineCloudUpload } from "react-icons/ai";
import { FcOvertime } from "react-icons/fc";
import { GoTools } from 'react-icons/go';

// import { tilesConstant } from './helpers/constant';

const tiles = [
    {
      sNo: 1,
      link: '/common/masterlistofToolList',
      isLink: true,
      clauseNo: 4,
      icon: <GoTools size="5rem" color="#343a40" />,
      p: 'Master List Of',
      span: 'Tool',
      isIcon: true,
    },
    {
      sNo: 2,
      link: '/common/obseleteMasterlistofToolList',
      isLink: true,
      clauseNo: 4,
      icon: <GoTools size="5rem" color="#343a40" />,
      p: 'Master List Of',
      span: 'Obselete Tool',
      isIcon: true,
    },
];

const Tiles = () => {
  return (
    <>
      <ChildHeader text={"Tool Room"} />
      {/* tilesConstant.childHeaderText */}
      <RenderTiles
        tilesObj={tiles}
        // height="100vh"
        // justify="start"
        // columns="0"
      />
    </>
  );
};

export default Tiles;
